import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3487e56c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-container" }, null, -1))
const _hoisted_3 = { style: {"padding":"8px"} }
const _hoisted_4 = { class: "pagination" }
const _hoisted_5 = {
  key: 0,
  class: "drawer-header-ar"
}
const _hoisted_6 = {
  key: 1,
  class: "drawer-header-all"
}
const _hoisted_7 = {
  key: 0,
  class: "drawer-header-ar"
}
const _hoisted_8 = {
  key: 1,
  class: "drawer-header-all"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "info-title" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "info-title" }
const _hoisted_13 = {
  key: 0,
  class: "info-title"
}
const _hoisted_14 = { class: "info-title" }
const _hoisted_15 = { class: "info-title" }
const _hoisted_16 = { class: "info-title" }
const _hoisted_17 = { class: "info-title" }
const _hoisted_18 = { class: "info-title" }
const _hoisted_19 = { class: "info-title" }
const _hoisted_20 = { class: "info-title" }
const _hoisted_21 = {
  key: 0,
  class: "drawer-header-ar"
}
const _hoisted_22 = {
  key: 1,
  class: "drawer-header-all"
}
const _hoisted_23 = { class: "label-form" }
const _hoisted_24 = { class: "label-form" }
const _hoisted_25 = { class: "label-form" }
const _hoisted_26 = {
  key: 0,
  class: "is-rtl"
}
const _hoisted_27 = {
  key: 1,
  class: "is-ltr"
}
const _hoisted_28 = {
  key: 0,
  class: "drawer-header-ar"
}
const _hoisted_29 = {
  key: 1,
  class: "drawer-header-all"
}
const _hoisted_30 = { class: "label-form" }
const _hoisted_31 = { class: "label-form" }
const _hoisted_32 = { class: "label-form" }
const _hoisted_33 = {
  key: 0,
  class: "is-ltr"
}
const _hoisted_34 = {
  key: 1,
  class: "is-rtl"
}
const _hoisted_35 = {
  key: 0,
  class: "drawer-header-ar-padding"
}
const _hoisted_36 = {
  key: 1,
  class: "drawer-header-all-padding"
}
const _hoisted_37 = {
  key: 0,
  class: "is-ltr"
}
const _hoisted_38 = {
  key: 1,
  class: "is-rtl"
}
const _hoisted_39 = { class: "label-form" }
const _hoisted_40 = { class: "label-form" }
const _hoisted_41 = { class: "label-form" }
const _hoisted_42 = { class: "label-form" }
const _hoisted_43 = { class: "label-form" }
const _hoisted_44 = { class: "label-form" }
const _hoisted_45 = { class: "label-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LbrxLoaderSpinner = _resolveComponent("LbrxLoaderSpinner")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SnippetsOutlined = _resolveComponent("SnippetsOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_check_circle_outlined = _resolveComponent("check-circle-outlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_search_outlined = _resolveComponent("search-outlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_LbrxLoaderSpinner, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_breadcrumb, {
        style: {"margin":"16px 0"},
        class: _normalizeClass({ 'is-rtl': _ctx.textDirection === 'rtl' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/'))),
            class: "breadcrumb-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Pos.Home")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Pos.Sales")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "add-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportReport()))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_DownloadOutlined)
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Pos.Export")) + " ", 1)
            ]),
            _: 1
          }),
          (_ctx.form.countselectedRowIds > 0)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                class: "add-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.multiselect()))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_SnippetsOutlined)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Pos.InvoiceDownload")) + " ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _hoisted_2,
    _createElementVNode("div", null, [
      _createVNode(_component_a_table, {
        class: "table-container",
        columns: _ctx.columns,
        "data-source": _ctx.reactiveData.data,
        pagination: false
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.key == 'actions')
            ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("Pos.View")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: ($event: any) => (_ctx.showDrawer(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_EyeOutlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("Pos.generateInvoice")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "report-btn",
                        onClick: ($event: any) => (_ctx.onSubmitInvoice(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_SnippetsOutlined)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key === 'created_at' || column.key === 'updated_at')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDisplayDate(record[column.key])), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'fullname')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(_ctx.formatcustomer(record)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'device')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDeviceName(record)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'currency')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.formatcurrency_code(record)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'total')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createTextVNode(_toDisplayString(_ctx.formatTotal(record)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'status')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                (record.is_paid == '0')
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      bordered: false,
                      color: "error"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_check_circle_outlined)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.unpaid")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (record.is_paid == '1')
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 1,
                      bordered: false,
                      color: "success"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_check_circle_outlined)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.paid")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key === 'checkbox')
            ? (_openBlock(), _createBlock(_component_a_checkbox, {
                key: 7,
                modelValue: record.checked,
                "onUpdate:modelValue": ($event: any) => ((record.checked) = $event),
                onChange: ($event: any) => (_ctx.handleCheckboxChange(record))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
            : _createCommentVNode("", true)
        ]),
        customFilterDropdown: _withCtx(({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          column,
        }) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_input, {
              ref: "searchInput",
              placeholder: `Search ${column.dataIndex}`,
              value: selectedKeys[0],
              style: {"width":"188px","margin-bottom":"8px","display":"block"},
              onChange: 
              (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
            ,
              onPressEnter: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, null, 8, ["placeholder", "value", "onChange", "onPressEnter"]),
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              style: {"width":"90px","margin-right":"8px"},
              onClick: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_SearchOutlined)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.Search")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              size: "small",
              style: {"width":"90px"},
              onClick: ($event: any) => (_ctx.handleReset(clearFilters))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("Pos.Reset")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        customFilterIcon: _withCtx(({ filtered }) => [
          _createVNode(_component_search_outlined, {
            style: _normalizeStyle({ color: filtered ? '#108ee9' : undefined })
          }, null, 8, ["style"])
        ]),
        _: 1
      }, 8, ["columns", "data-source"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_pagination, {
          class: "paginationArrows",
          "model:current": "currentPage",
          total: _ctx.form.customLastPage,
          onChange: _ctx.handlePageChange,
          "default-page-size": _ctx.perPage,
          showSizeChanger: false
        }, null, 8, ["total", "onChange", "default-page-size"]),
        (_ctx.form.customLastPage > 10)
          ? (_openBlock(), _createBlock(_component_a_select, {
              key: 0,
              class: "select-input",
              value: _ctx.customPagination,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customPagination) = $event)),
              placeholder: "Order By",
              onChange: _ctx.choosePerPage
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "10" }, {
                  default: _withCtx(() => [
                    _createTextVNode("10 / " + _toDisplayString(_ctx.t("Pos.page")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "20" }, {
                  default: _withCtx(() => [
                    _createTextVNode("20 / " + _toDisplayString(_ctx.t("Pos.page")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "50" }, {
                  default: _withCtx(() => [
                    _createTextVNode("50 / " + _toDisplayString(_ctx.t("Pos.page")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "100" }, {
                  default: _withCtx(() => [
                    _createTextVNode("100 / " + _toDisplayString(_ctx.t("Pos.page")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_a_drawer, {
        open: _ctx.open,
        "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.open) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        "root-style": { color: 'blue' },
        style: {"color":"red"},
        title: null,
        placement: _ctx.locale === 'ar' ? 'left' : 'right',
        width: _ctx.modalWidth,
        "body-style": { paddingBottom: '80px' },
        onAfterOpenChange: _ctx.afterOpenChange
      }, {
        title: _withCtx(() => [
          (_ctx.locale === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.saleDetails")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.locale !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.saleDetails")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "formRef",
            model: _ctx.form,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection === 'rtl' })
          }, {
            title: _withCtx(() => [
              (_ctx.locale === 'ar')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.DetailsWarehouseDrawer")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.locale !== 'ar')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.DetailsWarehouseDrawer")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      (_ctx.form.name != '')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t("Pos.Name")) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.form.name), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t("Pos.Customer")) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.passenger")), 1)
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        (_ctx.form.email != '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.t("Pos.Email")) + " :", 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.email), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t("Pos.worker")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.username), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t("Pos.Price")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.price), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t("Pos.Status")) + " :", 1),
                        (_ctx.form.status === 'paid')
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 0,
                              bordered: false,
                              color: "success"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_check_circle_outlined)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.paid")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.form.status === 'unpaid')
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 1,
                              bordered: false,
                              color: "error"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_check_circle_outlined)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.unpaid")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t("Pos.DiscountType")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.discount_type), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t("Pos.discount")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.form.discount), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t("Pos.CreatedAt")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDisplayDate(_ctx.form.createdAt)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t("Pos.Products")) + " :", 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.products, (sales, id) => {
                return (_openBlock(), _createBlock(_component_a_descriptions, {
                  key: id,
                  bordered: "",
                  size: "small",
                  class: "table-margin"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, {
                      label: _ctx.t('Pos.Name'),
                      span: 3
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sales.product.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]),
                    _createVNode(_component_a_descriptions_item, {
                      label: _ctx.t('Pos.Description'),
                      span: 3
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sales.product.description), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]),
                    _createVNode(_component_a_descriptions_item, {
                      label: _ctx.t('Pos.Price'),
                      span: 3
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sales.product.full_price), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["model", "class"])
        ]),
        _: 1
      }, 8, ["open", "placement", "width", "onAfterOpenChange"]),
      _createVNode(_component_a_drawer, {
        open: _ctx.openAdd,
        "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.openAdd) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        "root-style": { color: 'blue' },
        style: {"color":"red"},
        title: null,
        placement: _ctx.locale === 'ar' ? 'left' : 'right',
        width: _ctx.modalWidth,
        "body-style": { paddingBottom: '80px' },
        onAfterOpenChange: _ctx.afterOpenChange,
        onClose: _ctx.resetFields
      }, {
        title: _withCtx(() => [
          (_ctx.locale === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.GetInvoice")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.locale !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.GetInvoice")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          (_ctx.locale === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_ctx.reactiveData.action == 'update')
                  ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }))
                  : (_ctx.reactiveData.action == 'add')
                    ? (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _ctx.createInvoice
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Add")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: _ctx.hideForm
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_space, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: _ctx.hideForm
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
              ]))
            : _createCommentVNode("", true),
          (_ctx.locale !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (_ctx.reactiveData.action == 'update')
                  ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }))
                  : (_ctx.reactiveData.action == 'add')
                    ? (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _ctx.createInvoice
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Add")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: _ctx.hideForm
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_space, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: _ctx.hideForm
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "addFormRef",
            model: _ctx.form,
            rules: _ctx.rules,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection === 'rtl' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "customer_id" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t("Pos.Customer")), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_a_select, {
                            "show-search": "",
                            placeholder: _ctx.t('Pos.Customer'),
                            value: _ctx.form.customer_id,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.customer_id) = $event)),
                            onInput: _ctx.handleInput,
                            onChange: _ctx.handleChange,
                            key: _ctx.selectKey,
                            open: _ctx.isSelectOpen
                          }, _createSlots({
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: customer.id,
                                  value: customer.id,
                                  selected: customer.id === _ctx.form.customer_id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 2
                          }, [
                            (_ctx.customers.length === 0 && _ctx.startedTyping === true)
                              ? {
                                  name: "suffixIcon",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_LoadingOutlined)
                                  ]),
                                  key: "0"
                                }
                              : undefined,
                            (_ctx.customers.length === 0 && _ctx.startedTyping === true)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_LoadingOutlined),
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FilterCustomers")), 1)
                                  ]),
                                  key: "1"
                                }
                              : undefined
                          ]), 1032, ["placeholder", "value", "onInput", "onChange", "open"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "invoice_date" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.t("Pos.InvoiceDate")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            placeholder: _ctx.t('Pos.InvoiceDate'),
                            value: _ctx.form.invoice_date,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.invoice_date) = $event)),
                            class: "range-picker"
                          }, null, 8, ["placeholder", "value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "notes" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.t("Pos.Notes")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: _ctx.form.notes,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.notes) = $event)),
                            rows: 4,
                            placeholder: _ctx.t('Pos.Notes')
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "class"])
        ]),
        _: 1
      }, 8, ["open", "placement", "width", "onAfterOpenChange", "onClose"]),
      _createVNode(_component_a_drawer, {
        open: _ctx.openMultiple,
        "onUpdate:open": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.openMultiple) = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        "root-style": { color: 'blue' },
        style: {"color":"red"},
        title: null,
        placement: _ctx.locale === 'ar' ? 'left' : 'right',
        width: _ctx.modalWidth,
        "body-style": { paddingBottom: '80px' },
        onAfterOpenChange: _ctx.afterOpenChange,
        onClose: _ctx.resetFieldsMulitpleSelection
      }, {
        title: _withCtx(() => [
          (_ctx.locale === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.GetInvoice")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.locale !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.GetInvoice")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          (_ctx.locale !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                (_ctx.reactiveData.action == 'update')
                  ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }))
                  : (_ctx.reactiveData.action == 'add')
                    ? (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _ctx.handleMultiInvoice
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Add")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: _ctx.hideFormMultiple
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_space, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: _ctx.hideFormMultiple
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
              ]))
            : _createCommentVNode("", true),
          (_ctx.locale === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                (_ctx.reactiveData.action == 'update')
                  ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }))
                  : (_ctx.reactiveData.action == 'add')
                    ? (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _ctx.createInvoiceMultipleSelection
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Add")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: _ctx.hideFormMultiple
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_space, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: _ctx.hideFormMultiple
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "addFormRefForMultiple",
            model: _ctx.form,
            rules: _ctx.rules,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection === 'rtl' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "customer_id" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.t("Pos.Customer")), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_a_select, {
                            "show-search": "",
                            placeholder: _ctx.t('Pos.Customer'),
                            value: _ctx.form.customer_id,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.customer_id) = $event)),
                            onInput: _ctx.handleInput,
                            onChange: _ctx.handleChange,
                            key: _ctx.selectKey,
                            open: _ctx.isSelectOpen
                          }, _createSlots({
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: customer.id,
                                  value: customer.id,
                                  selected: customer.id === _ctx.form.customer_id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "selected"]))
                              }), 128))
                            ]),
                            _: 2
                          }, [
                            (_ctx.customers.length === 0 && _ctx.startedTyping === true)
                              ? {
                                  name: "suffixIcon",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_LoadingOutlined)
                                  ]),
                                  key: "0"
                                }
                              : undefined,
                            (_ctx.customers.length === 0 && _ctx.startedTyping === true)
                              ? {
                                  name: "notFoundContent",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_LoadingOutlined),
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("Pos.FilterCustomers")), 1)
                                  ]),
                                  key: "1"
                                }
                              : undefined
                          ]), 1032, ["placeholder", "value", "onInput", "onChange", "open"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "invoice_date" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.t("Pos.InvoiceDate")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            placeholder: _ctx.t('Pos.InvoiceDate'),
                            value: _ctx.form.invoice_date,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.invoice_date) = $event)),
                            class: "range-picker"
                          }, null, 8, ["placeholder", "value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "notes" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.t("Pos.Notes")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: _ctx.form.notes,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.notes) = $event)),
                            rows: 4,
                            placeholder: _ctx.t('Pos.Notes')
                          }, null, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "class"])
        ]),
        _: 1
      }, 8, ["open", "placement", "width", "onAfterOpenChange", "onClose"]),
      _createVNode(_component_a_modal, {
        open: _ctx.openTransferModal,
        "onUpdate:open": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.openTransferModal) = $event)),
        onOk: _ctx.handleTransferOk,
        onCancel: _ctx.closeModal,
        class: _normalizeClass({ 'is-rtl': _ctx.textDirection === 'rtl' })
      }, {
        title: _withCtx(() => [
          (_ctx.locale === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.ExportSales")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.locale !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.ExportSales")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          (_ctx.locale === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(_component_a_button, {
                  key: "submit",
                  type: "primary",
                  onClick: _ctx.handleTransferOk
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Pos.downloadFile")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  key: "back",
                  onClick: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.locale !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_a_button, {
                  key: "submit",
                  type: "primary",
                  onClick: _ctx.handleTransferOk
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Pos.downloadFile")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  key: "back",
                  onClick: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "formSalesRef",
            model: _ctx.form,
            rules: _ctx.rules,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': _ctx.textDirection === 'rtl' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "startDateForExport" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.t("Pos.startDate")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            placeholder: _ctx.t('Pos.startDate'),
                            value: _ctx.form.startDateForExport,
                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.startDateForExport) = $event)),
                            class: "range-picker"
                          }, null, 8, ["placeholder", "value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "endDateForExport" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.t("Pos.endDate")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            placeholder: _ctx.t('Pos.endDate'),
                            value: _ctx.form.endDateForExport,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.endDateForExport) = $event)),
                            class: "range-picker"
                          }, null, 8, ["placeholder", "value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "orderBy" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.t("Pos.OrderBy")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.form.orderBy,
                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.orderBy) = $event)),
                            placeholder: "Order By",
                            class: "input-form"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: "name" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("Pos.Name")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: "id" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("Pos.id")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: "unit" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("Pos.unit")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: "price" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("Pos.price")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: "total" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("Pos.total")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "order" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.t("Pos.OrderBy")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.form.order,
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.order) = $event)),
                            placeholder: "Order",
                            class: "input-form"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: "asc" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("Pos.Ascending")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: "desc" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t("Pos.Descending")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "export_type" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.t("Pos.ExportType")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.form.export_type,
                            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.export_type) = $event)),
                            placeholder: "Order",
                            class: "input-form"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: "pdf" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("PDF")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: "excel" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Excel")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "user" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.t("Pos.worker")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.form.user,
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.user) = $event)),
                            class: "input-form",
                            "show-search": "",
                            "option-filter-prop": 'label'
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactiveDataForUser.data, (user) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: user.id,
                                  value: user.id,
                                  label: user.first_name + ' ' + user.last_name
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(user.first_name + " " + user.last_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "device" }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.t("Pos.Device")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.form.device,
                            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.device) = $event)),
                            placeholder: _ctx.t('Pos.paymentType'),
                            class: "input-form",
                            "show-search": "",
                            "option-filter-prop": 'label'
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reactiveDataForDevice.data, (device) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: device.id,
                                  value: device.id,
                                  label: device.name
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(device.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "class"])
        ]),
        _: 1
      }, 8, ["open", "onOk", "onCancel", "class"])
    ])
  ], 64))
}